import {
    TradingProcedureListEventsPort
} from '../../../../features/trading-procedure-list/application/ports/trading-procedure-list-events.port';
import { inject, DestroyRef } from '@angular/core';
import { Observable, map } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
    TradingProcedureReportingHubService
} from '../../../../core/hubs/trading-procedure-reporting-hub/trading-procedure-reporting.hub.service';
import { StatusChangeEvent } from '../../../domain/trading-procedure/models/trading-procedure.model';
import { toStatus } from '../mappers/trading-procedure.mapper';

export class TradingProcedureListEventsAdapter implements TradingProcedureListEventsPort {
    private readonly tradingProcedureReportingHubService = inject(TradingProcedureReportingHubService)
    private readonly destroyRef = inject(DestroyRef);

    statusChanged$: Observable<StatusChangeEvent>;

    constructor() {
        this.statusChanged$ = this.tradingProcedureReportingHubService.tradingProcedureStatusChanged$.pipe(
            map((event) => ({
                id: event.id,
                status: toStatus(event.status)
            })),
            takeUntilDestroyed(this.destroyRef)
        )
    }
}
